/* matchadays-cro-mobile-50g */
(() => {
  const mediaQuery = window.matchMedia('(max-width: 749px)');

  function init() {
    const sticky = document.querySelector('product-sticky-form');
    const card = sticky?.querySelector('.product-sticky-form__card');
    const productInfo = document.querySelector('product-info');
    const formId = sticky?.getAttribute('form');
    const productForm = formId ? document.forms[formId] : null;
    const primaryButton = productForm?.querySelector('button[type="submit"][name="add"]');
    const footer = document.querySelector('.footer-group');

    if (!sticky || !card || !productInfo || !primaryButton) return;

    let scheduled = false;

    function update() {
      scheduled = false;

      if (!mediaQuery.matches) {
        card.classList.remove('matchadays-cro-mobile-50g--force');
        return;
      }

      const infoRect = productInfo.getBoundingClientRect();
      const buttonRect = primaryButton.getBoundingClientRect();
      const footerTop = footer?.getBoundingClientRect().top ?? Number.POSITIVE_INFINITY;
      const stickyHeight = card.offsetHeight || 81;
      const infoReached = infoRect.top <= window.innerHeight * 0.57;
      const buttonBelowStickyZone =
        buttonRect.top >= window.innerHeight - stickyHeight - 12;
      const beforeFooter = footerTop > window.innerHeight;
      const forceVisible = infoReached && buttonBelowStickyZone && beforeFooter;

      card.classList.toggle('matchadays-cro-mobile-50g--force', forceVisible);
    }

    function schedule() {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    mediaQuery.addEventListener?.('change', schedule);
    schedule();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
